<template>
    <div class="h5xshzDetails">
        <div class="h5xsBox">
            <div class="xstitleBox">
                <div class="carouselWrapper">
                    <el-carousel ref="carouselRef" :interval="5000" :arrow="'never'" height="3.7rem"
                        indicator-position="none" @change="handleCarouselChange">
                        <el-carousel-item v-for="item in list" :key="item._id">
                            <div class="centerBox">
                                <img :src="commenUrl + item.zgtp" alt="">
                                <div class='boxWrite'>{{ item.zgmc }}</div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                    <div class="arrowBtn leftArrow" @click="goToPrev">
                        <img src="../../../assets/images/xszgDetail/leftjt.png" alt="">
                    </div>
                    <div class="arrowBtn rightArrow" @click="goToNext">
                        <img src="../../../assets/images/xszgDetail/rightjt.png" alt="">
                    </div>
                </div>
                <div class="yhbjBox">
                    <img class="yhbj" src="../../../assets/images/yhbj.png" alt="">
                </div>
            </div>

            <!-- 企业列表：统一外层容器，带背景 -->
            <div class="listBox">
                <!-- 超过5个企业时，轮播包裹在 listBox 内 -->
                <div v-if="zlqyPages.length > 1" class="carouselWrap">
                    <!-- 自定义左箭头 -->
                    <div class="customArrow customArrow--left" @click="enterpriseCarouselRef && enterpriseCarouselRef.prev()">
                        <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M609.408 149.376 277.76 489.6a32 32 0 0 0 0 44.672l331.648 340.352a29.12 29.12 0 0 0 41.728 0 30.592 30.592 0 0 0 0-42.752L339.264 511.936l311.872-319.872a30.592 30.592 0 0 0 0-42.688 29.12 29.12 0 0 0-41.728 0z"/></svg>
                    </div>

                    <el-carousel ref="enterpriseCarouselRef" :interval="5000" :arrow="'never'" height="8rem"
                        indicator-position="none" class="enterpriseCarousel">
                        <el-carousel-item v-for="(page, pIdx) in zlqyPages" :key="pIdx">
                            <div class="listfor">
                                <div class="itemFor" v-for="(i, k) in page" :key="k" @click="handleclickqyDetail(i._id)">
                                    <div class="itemleft" v-if="i.qytp">
                                        <img :src="commenUrl + i.qytp.split(',')[0]" alt="">
                                    </div>
                                    <div class="itemleft" v-else style='padding:0.32rem;box-sizing: border-box;'>
                                        <img style='width:0.72rem;height:0.72rem'
                                            src="../../../assets/images/xszgDetail/qytp.png" alt="">
                                    </div>
                                    <div class="itemright">
                                        <div class="title">{{ i.qymc }}</div>
                                        <div class="content">{{ i.qyjj }}</div>
                                    </div>
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>

                    <!-- 自定义右箭头 -->
                    <div class="customArrow customArrow--right" @click="enterpriseCarouselRef && enterpriseCarouselRef.next()">
                        <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.624a32 32 0 0 0 0-45.248L382.592 149.376a29.12 29.12 0 0 0-41.728-.064z"/></svg>
                    </div>
                </div>

                <!-- 不超过5个时，直接展示列表 -->
                <div v-else-if="zlqyPages.length === 1" class="listfor">
                    <div class="itemFor" v-for="(i, k) in zlqyPages[0]" :key="k" @click="handleclickqyDetail(i._id)">
                        <div class="itemleft" v-if="i.qytp">
                            <img :src="commenUrl + i.qytp.split(',')[0]" alt="">
                        </div>
                        <div class="itemleft" v-else style='padding:0.32rem;box-sizing: border-box;'>
                            <img style='width:0.72rem;height:0.72rem' src="../../../assets/images/xszgDetail/qytp.png"
                                alt="">
                        </div>
                        <div class="itemright">
                            <div class="title">{{ i.qymc }}</div>
                            <div class="content">{{ i.qyjj }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="zbbottom">
                <div class="bottomCon" style="margin-bottom:0.28rem">云览名企 VR探场 优企联动</div>
                <div class="bottomCon">即刻入馆 抢抓商机 18910514060</div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";

const router = useRouter();
const route = useRoute();
const { proxy } = getCurrentInstance();

const carouselRef = ref(null);
const enterpriseCarouselRef = ref(null);
const list = ref([]);
const zlqyPages = ref([]);
const currentId = ref(route.query.id);

const groupArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
    }
    return result;
};

const getListInfo = () => {
    proxy.$request({
        method: "post",
        url: "QPSTZX_SXYZG_SXYZGLIST",
        data: {},
    }).then((res) => {
        if (res.data.code == "000") {
            list.value = res.data.result;
        }
    });
};

const getZgDetail = (id) => {
    zlqyPages.value = [];
    proxy.$request({
        method: "post",
        url: "QPSTZX_SXYZG_ZGQYLIST",
        data: {
            id: id,
            pageInfo: { pageSize: 100, pageNo: 1 }
        },
    }).then((res) => {
        if (res.data.code == "000") {
            zlqyPages.value = groupArray(res.data.result.list, 3);
        }
    });
};

const handleCarouselChange = (index) => {
    if (list.value[index]) {
        currentId.value = list.value[index]._id;
        getZgDetail(currentId.value);
    }
};

const goToPrev = () => {
    carouselRef.value?.prev();
};

const goToNext = () => {
    carouselRef.value?.next();
};

const handleclickqyDetail = (id) => {
    router.push({ name: 'h5qyDetails', query: { id } });
};

onMounted(() => {
    getListInfo();
    getZgDetail(route.query.id);
});
</script>

<style lang="less">
.h5xsBox {
    width: 100%;
    height: 100vh;
    background: url('../../../assets/images/ztbj.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    padding-top: 1rem;
    box-sizing: border-box;

    .xstitleBox {
        width: 100%;

        .carouselWrapper {
            width: 100%;
            height: 3.7rem;
            position: relative;
            overflow: hidden;
            // border-radius: 0.2rem;

            ::v-deep(.el-carousel__item) {
                height: 3.7rem;
            }

            .centerBox {
                width: 100%;
                height: 3.7rem;
                position: relative;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                }

                .boxWrite {
                    width: 100%;
                    height: 42px;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    font-size: 24px;
                    font-weight: 900;
                    color: #fff;
                    text-align: center;
                    overflow: hidden;
                }
            }

            .arrowBtn {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                width: 0.42rem;
                height: 0.42rem;
                cursor: pointer;
                z-index: 10;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .leftArrow {
                left: 0.2rem;
            }

            .rightArrow {
                right: 0.2rem;
            }
        }

        .yhbjBox {
            width: 100%;
            display: flex;
            justify-content: space-around;

            .yhbj {
                width: 6.24rem;
                height: 1.5rem;
                margin: -0.4rem auto 0;
            }
        }
    }

    .listBox {
        width: 100%;
        height: 8rem;
        padding: 0.3rem;
        box-sizing: border-box;

        // 轮播包装器 - 相对定位，箭头绝对定位到边缘
        .carouselWrap {
            position: relative;
            width: 100%;
            height: 100%;

            // 自定义箭头
            .customArrow {
                position: absolute;
                top: 30%;
                transform: translateY(-50%);
                width: 0.62rem;
                height: 0.62rem;
                border-radius: 50%;
                background: rgba(0, 0, 0, 0.2);
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                z-index: 10;
                color: #fff;

                svg {
                    width: 0.24rem;
                    height: 0.24rem;
                }

                &.customArrow--left {
                    left: -10px;
                }

                &.customArrow--right {
                    right: -10px;
                }
            }

            // 轮播容器
            .enterpriseCarousel {
                width: 100%;
                height: 100%;
            }
        }


        .listfor {
            width: 100%;
            height: 8rem;
            box-sizing: border-box;
            padding: 0 0.3rem;
            background: linear-gradient(0deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0) 100%);
        }

        .itemFor {
            width: 100%;
            height: 1.36rem;
            display: flex;
            margin-bottom: 0.2rem;

            .itemleft {
                width: 1.36rem;
                height: 1.36rem;
                margin-right: 0.3rem;
                background: #E1EAF9;
                border-radius: 0.08rem;

                img {
                    width: 1.36rem;
                    height: 1.36rem;
                }
            }

            .itemright {
                height: 1.36rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .title {
                    width: 100%;
                    height: 0.4rem;
                    font-weight: 600;
                    font-size: 0.28rem;
                    color: #313A4B;
                    line-height: 0.4rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .content {
                    height: 0.8rem;
                    font-size: 0.24rem;
                    color: #748199;
                    line-height: 0.4rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
            }
        }
    }

    .zbbottom {
        width: 100%;
        height: 3rem;
        background: url('../../../assets/images/zbbottom.png') no-repeat;
        background-size: 100% 100%;
        padding-top: 1.6rem;
        box-sizing: border-box;
        position:absolute;
        bottom:0;

        .bottomCon {
            font-size: 0.36rem;
            color: #FFFFFF;
            font-weight: 900;
            margin: 0 auto;
            width: 100%;
            text-align: center;
        }
    }
}
</style>
